<template>
	<layout-main-component class="watch-chat">
		<h1 slot="header">Chat</h1>
		<div class="container">
			<div class="watches-container">
				<spinner v-if="watches.loading" class="spinner"/>
				<div v-else class="watches">
					<button v-for="watch in watches.data" :key="watch.id" :ref="`watch_${watch.id}`" @click="selectWatch(watch)" class="desktop watch btn btn-round" :class="isSelected(watch) ? 'btn-success' : 'btn-primary'">{{ watch.profile_name }}</button>
					<select v-model="selected" class="mobile">
						<option v-for="watch in watches.data" :key="watch.id" :value="watch">{{ watch.profile_name }}</option>
					</select>
				</div>
			</div>
			<div class="messages-container">
				<spinner v-if="messages.loading" class="spinner"/>
				<div v-if="!messages.loading && watches.data.length" class="messages-wrapper" ref="messages">
					<div class="messages">
						<message v-for="message in messages.data" :key="message.id" :model="message" :user_uid="user_uid" :watch_id="watch_id"/>
						<p v-if="!messages.data.length">No messages found.</p>
					</div>
				</div>
				<div v-if="!messages.loading && watches.data.length" class="send-message-wrapper">
					<form @submit.prevent="validateAndSubmit">
						<input-text v-model="message.message" name="chat_message" placeholder="Message" class="form-group-simple"/>
						<div class="btn-group">
							<button-submit :loading="message.loading" class="btn-sm">Send</button-submit>
							<button class="btn btn-sm btn-primary btn-round" @click.prevent="startRecording">Record</button>
						</div>
					</form>
				</div>
			</div>
		</div>
		<modal-box @close="closeRecordingModal" header="Recording" class="modal-recording" v-if="showRecordingModal">
			<div class="flash">
				<span>RECORDING</span>
				<shape src="/static/svg/microphone.svg"/>
				<div>
					<span>{{ timerMinutes }} : {{ timerSeconds }}</span>
					<button @click="closeRecordingModal" class="btn btn-primary btn-round">STOP</button>
				</div>
			</div>
		</modal-box>
		<!--audio-analyser :values="audioServiceValues"/-->
	</layout-main-component>
</template>

<script>
import AudioService from '@/services/AudioService'
import Message from './Message'
//import AudioAnalyser from './AudioAnalyser'
export default {
	components: {
		Message,
		//AudioAnalyser
	},
	props: [
		'user_uid',
		'watch_id'
	],
	data () {
		return {
			watches: {
				loading: false,
				data: [],
				error: null
			},
			selected: null,
			messages: {
				loading: false,
				data: []
			},
			message: {
				loading: false,
				message: '',
				attachment: ''
			},
			audioService: null,
			showRecordingModal: false,
			timer: 0,
			interval: null,
			audioServiceValues: []
		}
	},
	watch: {
		selected () {
			this.message.message = ''
			this.getMessages()
		},
		watches: {
			handler (val, oldVal) {
				this.$nextTick(() => {
					if (this.$refs[`watch_${this.watch_id}`]) {
						this.scrollWatches()
						this.selectDefault()
					}
				})
			},
			deep: true
		},
		messages: {
			handler (val, oldVal) {
				this.$nextTick(() => {
					if (this.$refs.messages) {
						this.scrollMessages()
					}
				})
			},
			deep: true
		}
	},
	computed: {
		timerMinutes () {
			return (Math.floor(this.timer / 60)).toString().padStart(2, '0')
		},
		timerSeconds () {
			return (this.timer % 60).toString().padStart(2, '0')
		}
	},
	methods: {
		validateAndSubmit () {
			this.$validator.validateAll().then(result => {
				if (result && this.message.message) {
					this.sendMessage()
				}
			})
		},
		selectDefault () {
			if (this.watches.data.length) {
				this.selected = this.watches.data.find(element => element.id == this.watch_id)
			}
		},
		selectWatch (watch) {
			this.selected = watch
		},
		isSelected (watch) {
			return this.selected === watch
		},
		scrollWatches () {
			const ref = `watch_${this.watch_id}`
			// Ref is an array! Pick first item.
			// https://vuejs.org/v2/api/#ref
			// When used on elements/components with v-for,
			// the registered reference will be an Array
			// containing DOM nodes or component instances.
			const element = this.$refs[ref][0]
			if (element) {
				element.scrollIntoView()
			}
		},
		scrollMessages () {
			const element = this.$refs.messages
			element.scrollTop = element.scrollHeight
		},
		getWatches () {
			this.watches.loading = true
			this.$api.watches.getAll(this, this.user_uid).then(response => {
				this.$log.info('user dashboard', 'watches.getAll OK', response)()
				this.watches.data = response.body
			}).catch(error => {
				this.$log.error('user dashboard', 'watches.getAll ERROR', error)()
				this.error = error
			}).finally(() => {
				this.watches.loading = false
			})
		},
		getMessages () {
			this.messages.loading = true
			this.messages.data = []
			this.$api.chat.getAllByWatch(this, this.user_uid, this.selected.id).then(response => {
				this.$log.info('watch chat', 'chat.getAllByWatch OK', response)()
				this.messages.data = response.body
			}).catch(errors => {
				this.$log.error('watch chat', 'chat.getAllByWatch ERROR', errors)()
			}).finally(() => {
				this.messages.loading = false
			})
		},
		sendMessage () {
			this.message.loading = true
			let model = {
				message: this.message.message,
				attachment: this.message.attachment,
				reading_time: ''
			}
			this.$api.chat.add(this, this.user_uid, this.selected.id, model).then(response => {
				this.$log.info('watch chat', 'chat.add OK', response)()
				this.messages.data.push(response.body)
			}).catch(errors => {
				this.$log.error('watch chat', 'chat.add ERROR', errors)()
			}).finally(() => {
				this.message.message = ''
				this.message.attachment = ''
				this.message.loading = false
			})
		},
		startRecording () {
			this.audioService.startRecording(60)
		},
		closeRecordingModal () {
			this.audioService.stopRecording()
		}
	},
	beforeCreate () {
		this.$title('Chat')
	},
	created () {
		this.getWatches()
		this.audioService = new AudioService(this)
		this.audioService.initProcessor()
		this.audioService.onStart = () => {
			this.showRecordingModal = true
			this.timer = 0
			this.interval = setInterval(() => {
				this.timer++
			}, 1000)
		}
		this.audioService.onStop = () => {
			this.showRecordingModal = false
			clearInterval(this.interval)
		}
		this.audioService.onSuccess = (attachment) => {
			this.message.attachment = attachment
			this.sendMessage()
			this.$root.$emit('add-floating-box', { type: 'success', title: 'Success', message: 'Recording sent.' })
		}
		this.audioService.onError = error => {
			//this.$root.$emit('add-floating-box', { title: 'Error', message: error })
		}
		this.audioService.onValues = values => {
			this.audioServiceValues = values
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/watch/chat/Chat.vue